import React from "react"

import { AdContainer, AdImage } from "./styles"

const MBGAd = ({
  className,
  cloudinaryUrl,
  widthMobile,
  widthNonMobile,
  aspectRatio,
  url,
  title,
  dataId,
  ...props
}) => (
  <AdContainer
    className={className}
    data-exp-id={dataId}
    widthNonMobile={widthNonMobile}
    widthMobile={widthMobile}
    {...props}
  >
    <h5>Advertisement</h5>
    <a href={url} target="_blank" rel="noopener noreferrer" title={title}>
      <AdImage
        aspectRatio={aspectRatio}
        baseUrl={cloudinaryUrl}
        images={[
          {
            screenSize: 1024,
            transforms: `c_fill,g_auto,w_${widthNonMobile},h_${Math.round(
              widthNonMobile * aspectRatio,
            )},q_auto,f_auto,fl_lossy`,
          },
          {
            screenSize: 768,
            transforms: `c_fill,g_auto,w_${widthNonMobile},h_${Math.round(
              widthNonMobile * aspectRatio,
            )},q_auto,f_auto,fl_lossy`,
          },
          {
            transforms: `c_fill,g_auto,w_${widthMobile},h_${Math.round(
              widthMobile * aspectRatio,
            )},q_auto,f_auto,fl_lossy`,
          },
        ]}
        lazy
      />
    </a>
  </AdContainer>
)

export default MBGAd
